import {axiosInstance} from "./base"
import {getAuthSession} from "../helpers/auth.helper";


export function postClientQry(data) {
    return axiosInstance.post("api/clients/", data, {})
}

export function getUsers(params) {
    return axiosInstance.get("api/users/", {params})
}

export function getClientsQry(params) {
    return axiosInstance.get("api/clients/", {params})
}

export function getContractsQry(id) {
    return axiosInstance.get(`api/clients/${id}/contracts/`, {})
}

export function getContractQry(clientId, contractId) {
    return axiosInstance.get(`api/clients/${clientId}/contracts/${contractId}/`, {})
}

export function getClientQry(id) {
    return axiosInstance.get(`api/clients/${id}`)
}

export function putClientQry(id, data) {
    return axiosInstance.put(`api/clients/${id}/`, data, {})
}

export function patchClientQry(id, data) {
    return axiosInstance.patch(`api/clients/${id}/`, data, {})
}
export function optionClientQry() {
    return axiosInstance.options(`api/clients/`, {})
}

export function deleteClientQry(id) {
    return axiosInstance.delete(`api/clients/${id}/`, {})
}

export function getClientUserOverviewQry(id) {
    return axiosInstance.get(`api/clients/${id}/users-overview/`, {})
}

/* Onboard the first manager of a client (Lot F). */
export function onboardManagerQry(client_id, data) {
    return axiosInstance.post(`api/clients/${client_id}/onboard-manager/`, data, {})
}

export function postValidateDomainQry(data) {
    return axiosInstance.post(`api/clients/validate-domain/`, data, {})
}

export function getClientDomainQry(client_id) {
    return axiosInstance.get(`api/clients/${client_id}/domains/`, {})
}

export function postClientDomainQry(client_id, data) {
    return axiosInstance.post(`api/clients/${client_id}/domains/`, data, {})
}

export function deleteClientDomainQry(client_id, domain_id) {
    return axiosInstance.delete(`api/clients/${client_id}/domains/${domain_id}/`, {})
}

export function getClientSettings(client) {
    return axiosInstance.get(`api/clients/settings/`, {params:{client: client}})
}

export function putClientSettings(client, data) {
    return axiosInstance.put(`api/clients/settings/`, data, {params:{client: client}})
}

export function patchClientSettings(client, data) {
    return axiosInstance.patch(`api/clients/settings/`, data, {params:{client: client}})
}
